import { SVGProps } from 'react';

export const AvatarIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={47}
      height={48}
      viewBox="0 0 47 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M37.9538 40.2522C36.2652 38.0165 34.0805 36.2034 31.5718 34.9558C29.0632 33.7081 26.2991 33.0601 23.4973 33.0626C20.6955 33.0601 17.9314 33.7081 15.4228 34.9558C12.9141 36.2034 10.7294 38.0165 9.04081 40.2522M37.9538 40.2522C41.2489 37.3212 43.5728 33.4579 44.6218 29.1744C45.6708 24.891 45.3929 20.3898 43.825 16.2679C42.2571 12.146 39.4732 8.59815 35.8426 6.09478C32.212 3.5914 27.9061 2.25082 23.4961 2.25082C19.0861 2.25082 14.7802 3.5914 11.1496 6.09478C7.51897 8.59815 4.7351 12.146 3.16718 16.2679C1.59926 20.3898 1.32137 24.891 2.37037 29.1744C3.41936 33.4579 5.74568 37.3212 9.04081 40.2522M37.9538 40.2522C33.976 43.8003 28.8276 45.7577 23.4973 45.7501C18.1662 45.7583 13.0192 43.8009 9.04081 40.2522M30.7473 18.5626C30.7473 20.4854 29.9835 22.3295 28.6238 23.6891C27.2642 25.0488 25.4201 25.8126 23.4973 25.8126C21.5745 25.8126 19.7304 25.0488 18.3708 23.6891C17.0111 22.3295 16.2473 20.4854 16.2473 18.5626C16.2473 16.6398 17.0111 14.7957 18.3708 13.4361C19.7304 12.0764 21.5745 11.3126 23.4973 11.3126C25.4201 11.3126 27.2642 12.0764 28.6238 13.4361C29.9835 14.7957 30.7473 16.6398 30.7473 18.5626Z"
        stroke="#1F1F1F"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
